module.exports = __webpack_public_path__ + "img/Apio-Hero-Background.a89e80c1.png";